import { compose } from 'ramda'
import { sortReplies } from '@btime/helpers'
import React from 'react'

import { formatBlockReplies } from './_helpers/formatBlocks'
import { groupedRepliesByCategory } from './_helpers/groupByCategories'
import CategoriesList from './categories/CategoriesList'

const DynamicPresentationList = ({ children, replies, ignoreFilter, ...props }) => {
  const categories = React.useMemo(
    () =>
      compose(
        groupedRepliesByCategory, //
        replies => formatBlockReplies(replies, ignoreFilter),
        sortReplies
      )(replies),
    []
  )

  return (
    <>
      {children}
      <CategoriesList categories={categories} {...props} />
    </>
  )
}

export default DynamicPresentationList
